class AgeGate extends HTMLElement {
    constructor() {
        super();
        this.selectors = {
            close: '.close-modal',
            noButton: '[data-no-button]',
            yesButton: '[data-yes-button]'
        };
        if(!this.querySelector(this.selectors.noButton) || !this.querySelector(this.selectors.yesButton)) return;

        const ageCheckPassed = localStorage.getItem('age_check_passed');

        //check if age check is set in localstorage
        if(ageCheckPassed && ageCheckPassed === 'yes') {
            this.classList.add('hide');
        } else if(ageCheckPassed && ageCheckPassed === 'no'){
            this.redirectToHome();
        } else {
            localStorage.removeItem('age_check_passed');
            this.classList.remove('hide');
        }

        //close popup
        this.querySelectorAll(this.selectors.close)?.length && [...this.querySelectorAll(this.selectors.close)].forEach(el => {
            el.addEventListener('click', () => {
                this.classList.add('hide');
                this.redirectToHome();
            });
        });

        //set customer metafield and localStorage on yesButton click
        this.querySelector(this.selectors.yesButton)?.addEventListener('click', () => {
            localStorage.setItem('age_check_passed', 'yes');
            // if(this.dataset.customerId){
            //   this.setCustomerMetafield(this.dataset.customerId, "True");
            // } else {
              this.classList.add('hide');
            //}
        });

        //set customer metafield and localStorage on noButton click
        this.querySelector(this.selectors.noButton)?.addEventListener('click', () => {
            localStorage.setItem('age_check_passed', 'no');
            // if(this.dataset.customerId){
            //   this.setCustomerMetafield(this.dataset.customerId, "False");
            // } else {
              this.redirectToHome();
            //}
        });
    }
    setCustomerMetafield(customerId, metaValue){
        const _this = this;
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            "customerId": customerId,
            "ageCheckPassed": metaValue
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        fetch("https://us-central1-fareastflora.cloudfunctions.net/function-1", requestOptions)
        .then((response) => response.json())
        .then((result) => {
            if(!!result?.data?.metafieldsSet?.userErrors?.length){
                localStorage.removeItem('age_check_passed');
            } else {
                if(metaValue === 'True'){
                    _this.classList.add('hide');
                } else if(metaValue === 'False'){
                    _this.redirectToHome();
                }
            }
        })
        .catch((error) => console.error(error));
    }

    redirectToHome(){
        window.location.href = '/';
    }
}
customElements.define('age-gate', AgeGate);